import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

class Footer extends Component {
    render() {
        return (
            <React.Fragment>
                <footer className="footer">
                    <div className="container-fluid">
                        <Row>
                            <Col style={{ textAlign: 'center' }} sm={12}>
                                {new Date().getFullYear()} © {process.env.REACT_APP_APP_NAME}
                            </Col>
                        </Row>
                    </div>
                </footer>
            </React.Fragment>
        );
    }
}

export default Footer;
